import _asyncToGenerator from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WalletNotConnectedError, WalletNotReadyError, WalletReadyState } from '@solana/wallet-adapter-base';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { WalletNotSelectedError } from './errors.mjs';
import { useLocalStorage } from './useLocalStorage.mjs';
import { WalletContext } from './useWallet.mjs';
var initialState = {
  wallet: null,
  adapter: null,
  publicKey: null,
  connected: false
};
export var WalletProvider = function WalletProvider(_ref) {
  var children = _ref.children,
      adapters = _ref.wallets,
      _ref$autoConnect = _ref.autoConnect,
      autoConnect = _ref$autoConnect === void 0 ? false : _ref$autoConnect,
      onError = _ref.onError,
      _ref$localStorageKey = _ref.localStorageKey,
      localStorageKey = _ref$localStorageKey === void 0 ? 'walletName' : _ref$localStorageKey;

  var _useLocalStorage = useLocalStorage(localStorageKey, null),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      name = _useLocalStorage2[0],
      setName = _useLocalStorage2[1];

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      wallet = _useState2$.wallet,
      adapter = _useState2$.adapter,
      publicKey = _useState2$.publicKey,
      connected = _useState2$.connected,
      setState = _useState2[1];

  var readyState = (adapter === null || adapter === void 0 ? void 0 : adapter.readyState) || WalletReadyState.Unsupported;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      connecting = _useState4[0],
      setConnecting = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      disconnecting = _useState6[0],
      setDisconnecting = _useState6[1];

  var isConnecting = useRef(false);
  var isDisconnecting = useRef(false);
  var isUnloading = useRef(false); // Wrap adapters to conform to the `Wallet` interface

  var _useState7 = useState(function () {
    return adapters.map(function (adapter) {
      return {
        adapter: adapter,
        readyState: adapter.readyState
      };
    });
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      wallets = _useState8[0],
      setWallets = _useState8[1]; // When the wallets change, start to listen for changes to their `readyState`


  useEffect(function () {
    function handleReadyStateChange(readyState) {
      var _this = this;

      setWallets(function (prevWallets) {
        var walletIndex = prevWallets.findIndex(function (_ref2) {
          var adapter = _ref2.adapter;
          return adapter.name === _this.name;
        });
        if (walletIndex === -1) return prevWallets;
        return [].concat(_toConsumableArray(prevWallets.slice(0, walletIndex)), [_objectSpread(_objectSpread({}, prevWallets[walletIndex]), {}, {
          readyState: readyState
        })], _toConsumableArray(prevWallets.slice(walletIndex + 1)));
      });
    }

    var _iterator = _createForOfIteratorHelper(adapters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _adapter2 = _step.value;

        _adapter2.on('readyStateChange', handleReadyStateChange, _adapter2);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return function () {
      var _iterator2 = _createForOfIteratorHelper(adapters),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _adapter = _step2.value;

          _adapter.off('readyStateChange', handleReadyStateChange, _adapter);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
  }, [adapters]); // When the selected wallet changes, initialize the state

  useEffect(function () {
    var wallet = wallets.find(function (_ref3) {
      var adapter = _ref3.adapter;
      return adapter.name === name;
    });

    if (wallet) {
      setState({
        wallet: wallet,
        adapter: wallet.adapter,
        connected: wallet.adapter.connected,
        publicKey: wallet.adapter.publicKey
      });
    } else {
      setState(initialState);
    }
  }, [name, wallets]); // If autoConnect is enabled, try to connect when the adapter changes and is ready

  useEffect(function () {
    if (isConnecting.current || connecting || connected || !autoConnect || !adapter || !(readyState === WalletReadyState.Installed || readyState === WalletReadyState.Loadable)) return;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isConnecting.current = true;
              setConnecting(true);
              _context.prev = 2;
              _context.next = 5;
              return adapter.connect();

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              // Clear the selected wallet
              setName(null); // Don't throw error, but handleError will still be called

            case 10:
              _context.prev = 10;
              setConnecting(false);
              isConnecting.current = false;
              return _context.finish(10);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7, 10, 14]]);
    }))();
  }, [isConnecting, connecting, connected, autoConnect, adapter, readyState]); // If the window is closing or reloading, ignore disconnect and error events from the adapter

  useEffect(function () {
    function listener() {
      isUnloading.current = true;
    }

    window.addEventListener('beforeunload', listener);
    return function () {
      return window.removeEventListener('beforeunload', listener);
    };
  }, [isUnloading]); // Handle the adapter's connect event

  var handleConnect = useCallback(function () {
    if (!adapter) return;
    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        connected: adapter.connected,
        publicKey: adapter.publicKey
      });
    });
  }, [adapter]); // Handle the adapter's disconnect event

  var handleDisconnect = useCallback(function () {
    // Clear the selected wallet unless the window is unloading
    if (!isUnloading.current) setName(null);
  }, [isUnloading]); // Handle the adapter's error event, and local errors

  var handleError = useCallback(function (error) {
    // Call onError unless the window is unloading
    if (!isUnloading.current) (onError || console.error)(error);
    return error;
  }, [isUnloading, onError]); // Setup and teardown event listeners when the adapter changes

  useEffect(function () {
    if (adapter) {
      adapter.on('connect', handleConnect);
      adapter.on('disconnect', handleDisconnect);
      adapter.on('error', handleError);
      return function () {
        adapter.off('connect', handleConnect);
        adapter.off('disconnect', handleDisconnect);
        adapter.off('error', handleError);
      };
    }
  }, [adapter, handleConnect, handleDisconnect, handleError]); // When the adapter changes, disconnect the old one

  useEffect(function () {
    return function () {
      adapter === null || adapter === void 0 ? void 0 : adapter.disconnect();
    };
  }, [adapter]); // Connect the adapter to the wallet

  var connect = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isConnecting.current || connecting || disconnecting || connected)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            if (adapter) {
              _context2.next = 4;
              break;
            }

            throw handleError(new WalletNotSelectedError());

          case 4:
            if (readyState === WalletReadyState.Installed || readyState === WalletReadyState.Loadable) {
              _context2.next = 8;
              break;
            }

            // Clear the selected wallet
            setName(null);

            if (typeof window !== 'undefined') {
              window.open(adapter.url, '_blank');
            }

            throw handleError(new WalletNotReadyError());

          case 8:
            isConnecting.current = true;
            setConnecting(true);
            _context2.prev = 10;
            _context2.next = 13;
            return adapter.connect();

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](10);
            // Clear the selected wallet
            setName(null); // Rethrow the error, and handleError will also be called

            throw _context2.t0;

          case 19:
            _context2.prev = 19;
            setConnecting(false);
            isConnecting.current = false;
            return _context2.finish(19);

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[10, 15, 19, 23]]);
  })), [isConnecting, connecting, disconnecting, connected, adapter, readyState, handleError]); // Disconnect the adapter from the wallet

  var disconnect = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(isDisconnecting.current || disconnecting)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            if (adapter) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", setName(null));

          case 4:
            isDisconnecting.current = true;
            setDisconnecting(true);
            _context3.prev = 6;
            _context3.next = 9;
            return adapter.disconnect();

          case 9:
            _context3.next = 15;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](6);
            // Clear the selected wallet
            setName(null); // Rethrow the error, and handleError will also be called

            throw _context3.t0;

          case 15:
            _context3.prev = 15;
            setDisconnecting(false);
            isDisconnecting.current = false;
            return _context3.finish(15);

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[6, 11, 15, 19]]);
  })), [isDisconnecting, disconnecting, adapter]); // Send a transaction using the provided connection

  var sendTransaction = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(transaction, connection, options) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (adapter) {
                _context4.next = 2;
                break;
              }

              throw handleError(new WalletNotSelectedError());

            case 2:
              if (connected) {
                _context4.next = 4;
                break;
              }

              throw handleError(new WalletNotConnectedError());

            case 4:
              _context4.next = 6;
              return adapter.sendTransaction(transaction, connection, options);

            case 6:
              return _context4.abrupt("return", _context4.sent);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x, _x2, _x3) {
      return _ref7.apply(this, arguments);
    };
  }(), [adapter, handleError, connected]); // Sign a transaction if the wallet supports it

  var signTransaction = useMemo(function () {
    return adapter && 'signTransaction' in adapter ? /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(transaction) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (connected) {
                  _context5.next = 2;
                  break;
                }

                throw handleError(new WalletNotConnectedError());

              case 2:
                _context5.next = 4;
                return adapter.signTransaction(transaction);

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }() : undefined;
  }, [adapter, handleError, connected]); // Sign multiple transactions if the wallet supports it

  var signAllTransactions = useMemo(function () {
    return adapter && 'signAllTransactions' in adapter ? /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(transactions) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (connected) {
                  _context6.next = 2;
                  break;
                }

                throw handleError(new WalletNotConnectedError());

              case 2:
                _context6.next = 4;
                return adapter.signAllTransactions(transactions);

              case 4:
                return _context6.abrupt("return", _context6.sent);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x5) {
        return _ref9.apply(this, arguments);
      };
    }() : undefined;
  }, [adapter, handleError, connected]); // Sign an arbitrary message if the wallet supports it

  var signMessage = useMemo(function () {
    return adapter && 'signMessage' in adapter ? /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(message) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (connected) {
                  _context7.next = 2;
                  break;
                }

                throw handleError(new WalletNotConnectedError());

              case 2:
                _context7.next = 4;
                return adapter.signMessage(message);

              case 4:
                return _context7.abrupt("return", _context7.sent);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x6) {
        return _ref10.apply(this, arguments);
      };
    }() : undefined;
  }, [adapter, handleError, connected]);
  return React.createElement(WalletContext.Provider, {
    value: {
      autoConnect: autoConnect,
      wallets: wallets,
      wallet: wallet,
      publicKey: publicKey,
      connected: connected,
      connecting: connecting,
      disconnecting: disconnecting,
      select: setName,
      connect: connect,
      disconnect: disconnect,
      sendTransaction: sendTransaction,
      signTransaction: signTransaction,
      signAllTransactions: signAllTransactions,
      signMessage: signMessage
    }
  }, children);
};